import { concatenate_paginatedRestResult, filterAndPaginateRestFieldDetails, filter_enforceOnlyAllowedFieldTypes, paginateContextResultWithoutFilter, transformDTOSetDefaultOptionToRESTrepresentationForHttpPut, transformJiraRestResponse, transformRestBulkGroupSearchResultToDTOs, transformRestBulkUserSearchResultToDTOs, transformRestDefaultValuesToDTOs, transformRestGroupSearchResultToDTOs, transformRestUserSearchResultToDTOs, fromToSliceOfListNullSafe, transformGroupIdList_To_RestBulkGroupSearchResultItem__WithUnknownGroupNamePlaceholder, mergeLeft_GroupName_of_RestBulkGroupSearchResultItem, transformUserAccountIdList_To_RestBulkUserSearchResultItem__WithUnknownDisplayNamePlaceholder, mergeLeft_DisplayNameAndAvatarUrl_of_RestBulkUserSearchResultItem, generateCreateObjectBasedOnParentOptionId_from_OptionDTOCreateOption, } from './transformer-service';
import { transformContextToDTO, transformFieldDetailsToDTO, transformRestMyselfToDTO } from './model/dto-transformers';
import { MAX_OPTIONS_PER_CONTEXT } from './limits';
import { returnError400WithEmptyPayload, returnErrorWithEmptyPayload, returnNoErrorWithPayload, } from './model/model';
import { generateErrorMessageFromErrorAndPayloadCustomFields, sanitizeUserInput_accountId, sanitizeUserInput_contextId, sanitizeUserInput_fieldId, sanitizeUserInput_filter, sanitizeUserInput_groupId, sanitizeUserInput_optionId, sanitizeUserInput_positiveNumber, sanitize_userOrGroupPickerQuery, toIntNullSafe, } from './util';
const DEFAULT_JSON_HEADERS = {
    headers: {
        Accept: 'application/json',
    },
};
export class ApiService {
    api;
    route;
    constructor(api, route) {
        this.api = api;
        this.route = route;
    }
    async rest_api_3_permissions_check___isUserAdmin___asUser() {
        const errorId = 'MYPERMISSIONS_783023';
        const response = await this.api.asUser().requestJira(this.route `/rest/api/3/mypermissions?permissions=ADMINISTER`, {
            headers: {
                Accept: 'application/json',
            },
        });
        const errorAndPayloadRestCheckPermissions = await transformJiraRestResponse(response, errorId);
        // console.log('errorAndPayloadRestCheckPermissions', JSON.stringify(errorAndPayloadRestCheckPermissions, null, 2));
        if (errorAndPayloadRestCheckPermissions.hasError === true) {
            return returnError400WithEmptyPayload('failed to check for admin role', errorId);
        }
        if (errorAndPayloadRestCheckPermissions.payload &&
            errorAndPayloadRestCheckPermissions.payload.permissions &&
            errorAndPayloadRestCheckPermissions.payload.permissions.ADMINISTER &&
            errorAndPayloadRestCheckPermissions.payload.permissions.ADMINISTER.havePermission === true) {
            return returnNoErrorWithPayload(null);
        }
        else {
            return returnError400WithEmptyPayload('user is not admin', errorId);
        }
    }
    async rest_api_3_myself___getLoggedInUserWithGroups___asUser() {
        const errorId = 'MYSELF_239943';
        const queryParams = new URLSearchParams();
        queryParams.append('expand', `groups`);
        const uriEscapedAndSafe = this.route `/rest/api/3/myself?${queryParams}`;
        const myselfResponse = await this.api.asUser().requestJira(uriEscapedAndSafe, DEFAULT_JSON_HEADERS);
        const errorAndPayloadMyself = await transformJiraRestResponse(myselfResponse, errorId);
        // console.log('invoke_getLoggedInUserWithGroups', errorAndPayloadMyself);
        if (errorAndPayloadMyself.hasError) {
            return returnErrorWithEmptyPayload(errorAndPayloadMyself);
        }
        else {
            return returnNoErrorWithPayload(transformRestMyselfToDTO(errorAndPayloadMyself.payload));
        }
    }
    // NOTE: Pagination is done in memory due to filter and passed field ids.
    // We fetch ALL fields user has permissions for. And when filter is applied, we can do that in memory
    // CURRENTLY WE LIMIT THIS TO 150 Fields, which would be 3 requests!
    async rest_api_3_field___getAllCustomFields__forUserWithPermissions___asApp(fieldIds, params) {
        const errorId = 'FIELDSEARCH_230547';
        //
        // GUARDS
        //
        if (!fieldIds || fieldIds.length === 0) {
            return returnError400WithEmptyPayload('fieldIds must be provided in non admin view', errorId);
        }
        //
        // LOGIC
        //
        //
        // (1) GET ALL FIELDS USER HAS PERMISSIONS FOR (MAX 150)
        //
        let maxCounter = 0;
        let startAt = 0;
        let hasNext = false;
        let allConcatedFields = [];
        do {
            const queryParams = new URLSearchParams(); // MUST BE INSIDE OF DO-LOOP OTHERWISE startAt=0&...&startAt=50&...&startAt=100 and atlassian will always take startAt=0
            for (const fieldId of fieldIds) {
                queryParams.append('id', fieldId);
            }
            queryParams.append('startAt', `${startAt}`);
            queryParams.append('maxResults', '50'); // WE REALLY FETCH THE FIELDS WE CAN GET BECAUSE WE NEED TO APPLY FILTER IN MEMORY! => 50 is MAX SERVERSIDE BY ATLASSIAN!
            queryParams.append('expand', 'isLocked');
            queryParams.append('type', 'custom');
            queryParams.append('orderBy', 'name');
            const uriEscapedAndSafe = this.route `/rest/api/3/field/search?${queryParams}`;
            const response = await this.api.asApp().requestJira(uriEscapedAndSafe, DEFAULT_JSON_HEADERS);
            const errorAndPayloadCustomFields = await transformJiraRestResponse(response, errorId);
            if (errorAndPayloadCustomFields.hasError) {
                return returnErrorWithEmptyPayload(errorAndPayloadCustomFields);
            }
            else {
                const concatfields = allConcatedFields.concat(errorAndPayloadCustomFields.payload.values);
                allConcatedFields = concatfields;
                hasNext = !errorAndPayloadCustomFields.payload.isLast;
            }
            maxCounter = maxCounter + 1;
            startAt = startAt + 50;
        } while (hasNext && maxCounter <= 3); // LIMIT TO 150 FIELDS! TO NOT HIT RATE LIMIT!
        //
        // (2) ENFORCE SECURITY (ENSURE ONLY FIELDS USER HAS PERMISSION FOR ARE PASSED UP!)
        //
        // NOTE: Since we are paranoid we filter out the fields the user has no access to here as well
        //       WHY? Because we cannot trust the API to only return the ones we requested via url param ids!!!!!
        const enforcedPermissionFilteredFields = allConcatedFields.filter((f) => fieldIds.includes(f.id));
        //
        // CALUCALTE PAGINATION AND SLICE
        //
        const paginatedFields = filterAndPaginateRestFieldDetails(enforcedPermissionFilteredFields, params);
        return returnNoErrorWithPayload(paginatedFields);
    }
    // PAGINATION AND FILTERING DONE VIA API (ADMIN ONLY!)
    async rest_api_3_field___getAllCustomFields__forAdmin___asApp(params) {
        const errorId = 'FIELDSEARCH_230928'; // DO NEVER CHANGE THIS - SPECIAL ERROR KEY USED IN FRONTEND!
        const queryParams = new URLSearchParams();
        queryParams.append('startAt', sanitizeUserInput_positiveNumber(`${params ? params.startAt : 0}`));
        queryParams.append('maxResults', `10`); // IS LIMITED TO MAX 50 BY ATLASSIAN! WE FETCH 10 and display ALL FIELDS (locked + incompatible) for now
        queryParams.append('expand', 'isLocked');
        if (params && params.currentFilter) {
            const sanitizedFilter = sanitizeUserInput_filter(params.currentFilter);
            if (sanitizedFilter.length > 0) {
                queryParams.append('query', sanitizedFilter);
            }
        }
        queryParams.append('type', 'custom');
        queryParams.append('orderBy', 'name');
        const uriEscapedAndSafe = this.route `/rest/api/3/field/search?${queryParams}`;
        const response = await this.api.asApp().requestJira(uriEscapedAndSafe, DEFAULT_JSON_HEADERS);
        const errorAndPayloadCustomFields = await transformJiraRestResponse(response, errorId);
        if (errorAndPayloadCustomFields.hasError === true) {
            console.log('URL FIELDSEARCH_230928', uriEscapedAndSafe);
            console.log('ERR FIELDSEARCH_230928', generateErrorMessageFromErrorAndPayloadCustomFields(errorAndPayloadCustomFields));
            return returnErrorWithEmptyPayload(errorAndPayloadCustomFields);
        }
        else {
            return returnNoErrorWithPayload(errorAndPayloadCustomFields.payload);
        }
    }
    async rest_api_3_field_search___getSingleCustomField___enforceValidTypeAndUnlocked___asApp(fieldId) {
        const queryParams = new URLSearchParams();
        const errorId = 'FIELDSEARCH_037580';
        const sanitizedFieldId = sanitizeUserInput_fieldId(`${fieldId}`);
        queryParams.append('id', sanitizedFieldId);
        queryParams.append('expand', 'isLocked');
        const uriEscapedAndSafe = this.route `/rest/api/3/field/search?${queryParams}`;
        // console.log('_getSingleCustomField uriEscapedAndSafe', uriEscapedAndSafe);
        const response = await this.api.asApp().requestJira(uriEscapedAndSafe, DEFAULT_JSON_HEADERS);
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        // console.log('errorAndPayload', JSON.stringify(errorAndPayload, null, 2));
        if (!errorAndPayload.hasError && errorAndPayload.payload.values && errorAndPayload.payload.values.length > 0) {
            const field = errorAndPayload.payload.values[0];
            if (!filter_enforceOnlyAllowedFieldTypes(field)) {
                return returnErrorWithEmptyPayload({ hasError: true, statusCode: 400, errorMessage: 'customfield type is not supported', errorId: errorId, payload: null });
            }
            else if (field.isLocked === true) {
                return returnErrorWithEmptyPayload({ hasError: true, statusCode: 400, errorMessage: 'customfield is locked', errorId: errorId, payload: null });
            }
            else {
                return returnNoErrorWithPayload(transformFieldDetailsToDTO(field));
            }
        }
        return returnErrorWithEmptyPayload({ hasError: true, statusCode: 400, errorMessage: 'customfield does not exist or invalid permissions', errorId: errorId, payload: null });
    }
    async rest_api_3_field_FIELDID_context_CONTEXTID_option___hasOptionChildOptions___asApp(fieldId, contextId, optionId) {
        const errorAndPayload = returnNoErrorWithPayload(false);
        const errorId = 'CTXOPTIONS_740182';
        const queryParams = new URLSearchParams();
        queryParams.append('maxResults', `2`);
        queryParams.append('startAt', `0`);
        queryParams.append('optionId', sanitizeUserInput_optionId(`${optionId}`));
        const response = await this.api.asApp().requestJira(this.route `/rest/api/3/field/${fieldId}/context/${contextId}/option?${queryParams}`);
        const errorAndPayloadInner = await transformJiraRestResponse(response, errorId);
        if (errorAndPayloadInner.hasError) {
            errorAndPayload.payload = false;
            errorAndPayload.hasError = true;
            errorAndPayload.statusCode = errorAndPayloadInner.statusCode;
            errorAndPayload.errorMessage = errorAndPayloadInner.errorMessage;
            return errorAndPayload;
        }
        // console.log('INNER', JSON.stringify(errorAndPayloadInner, null, 2));
        if (errorAndPayloadInner.payload.total > 1) {
            // note that always first option is parent itself!
            return returnNoErrorWithPayload(true);
        }
        else {
            return returnNoErrorWithPayload(false);
        }
    }
    async rest_api_3_field_FIELDID_context_CONTEXTID_option___getAllOptionsOfContext___asApp(fieldId, contextId, parentOptionId) {
        const errorId = 'CTXOPTIONS_743023';
        // Working with limit of MAX_OPTIONS_PER_CONTEXT without pagination in frontend
        const maxResultsPerRequest = 100; // NOTE: HARDCODED 100 maxResults limit by Atlassian!
        let resultCounter = 0;
        let errorAndPayload = returnNoErrorWithPayload({
            maxResults: 0,
            startAt: 0,
            total: 0,
            isLast: true,
            values: [],
        });
        do {
            const queryParams = new URLSearchParams();
            queryParams.append('maxResults', `${maxResultsPerRequest}`);
            queryParams.append('startAt', `${resultCounter}`);
            if (parentOptionId) {
                // get all childoptions of parent (WARN: First option returned will always be the parent see https://github.com/codeclou/customfield-editor-for-jira-cloud/issues/2)
                queryParams.append('optionId', sanitizeUserInput_optionId(`${parentOptionId}`));
            }
            else {
                // When no parentOptionId is specified we get only the parent options from the API
                queryParams.append('onlyOptions', `true`);
            }
            //console.log('DOING REQUEST WITH ', queryParams.toString());
            const uriEscapedAndSafe = this.route `/rest/api/3/field/${fieldId}/context/${contextId}/option?${queryParams}`;
            // console.log('options url:', uriEscapedAndSafe);
            const response = await this.api.asApp().requestJira(uriEscapedAndSafe);
            const errorAndPayloadInner = await transformJiraRestResponse(response, errorId);
            if (errorAndPayloadInner.hasError) {
                return errorAndPayloadInner;
            }
            resultCounter = resultCounter + toIntNullSafe(errorAndPayloadInner.payload.maxResults);
            errorAndPayload = concatenate_paginatedRestResult(errorAndPayload, errorAndPayloadInner);
        } while (errorAndPayload && errorAndPayload.hasError === false && errorAndPayload.payload && errorAndPayload.payload.isLast === false && resultCounter < MAX_OPTIONS_PER_CONTEXT);
        errorAndPayload.payload.startAt = 0;
        errorAndPayload.payload.maxResults = errorAndPayload.payload.total;
        if (parentOptionId) {
            // SPECIAL CASE: When requesting child options on cascade, then we need to remove the first option, because it is the parentOption
            errorAndPayload.payload.total = errorAndPayload.payload.total - 1;
            errorAndPayload.payload.maxResults = errorAndPayload.payload.maxResults - 1;
            errorAndPayload.payload.values = errorAndPayload.payload.values.filter((o) => `${o.id}` !== `${parentOptionId}`);
        }
        return errorAndPayload;
    }
    async rest_api_3_field_FIELDID_context_CONTEXTID_option___getSingleOptionOfContext___asApp(fieldId, contextId, optionId) {
        const errorId = 'CTXOPTION_252375';
        const queryParams = new URLSearchParams();
        queryParams.append('maxResults', `1`);
        queryParams.append('startAt', `0`);
        queryParams.append('optionId', sanitizeUserInput_optionId(`${optionId}`));
        const uriEscapedAndSafe = this.route `/rest/api/3/field/${fieldId}/context/${contextId}/option?${queryParams}`;
        const response = await this.api.asApp().requestJira(uriEscapedAndSafe);
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        if (errorAndPayload.hasError) {
            return returnErrorWithEmptyPayload(errorAndPayload);
        }
        if (!errorAndPayload.payload.values || !errorAndPayload.payload.values[0]) {
            // return null if no option found
            return returnNoErrorWithPayload(null);
        }
        return returnNoErrorWithPayload(errorAndPayload.payload.values[0]);
    }
    async rest_api_3_field_FIELDID_context___getSingleCustomFieldContext___asApp(params) {
        const errorId = 'FLDCONTEXT_681373';
        const queryParams = new URLSearchParams();
        queryParams.append('maxResults', `1`);
        queryParams.append('startAt', `0`);
        queryParams.append('contextId', sanitizeUserInput_contextId(`${params.contextId}`));
        const sanitizedFieldId = sanitizeUserInput_fieldId(params.fieldId);
        const uriEscapedAndSafe = this.route `/rest/api/3/field/${sanitizedFieldId}/context?${queryParams}`;
        const response = await this.api.asApp().requestJira(uriEscapedAndSafe, DEFAULT_JSON_HEADERS);
        const errorAndPayloadPaginated = await transformJiraRestResponse(response, errorId);
        if (errorAndPayloadPaginated.hasError) {
            return returnErrorWithEmptyPayload(errorAndPayloadPaginated);
        }
        if (errorAndPayloadPaginated.payload && errorAndPayloadPaginated.payload.values && errorAndPayloadPaginated.payload.values.length > 0) {
            return returnNoErrorWithPayload(transformContextToDTO(errorAndPayloadPaginated.payload.values[0]));
        }
        else {
            return returnError400WithEmptyPayload('No context found for id', errorId);
        }
    }
    async rest_api_3_field_FIELDID_context___getAllCustomFieldContexts__forUserWithPermissions___asApp(contextIds, params) {
        const errorId = 'FLDCONTEXT_345173';
        //
        // GUARDS
        //
        if (!contextIds || contextIds.length === 0) {
            return returnError400WithEmptyPayload('contextIds must be provided in non admin view', errorId);
        }
        //
        // BUSINESS LOGIC
        //
        const maxResultsPerPaginatedPage = 20; // Slice we want to show in frontend
        const maxResultsOverall = 300; // We limit it to max 3 requests (rate limit)
        const maxResultsPerRequest = 100; // NOTE: HARDCODED 100 maxResults limit by Atlassian!
        let errorAndPayload = returnNoErrorWithPayload({
            maxResults: 0,
            startAt: 0,
            total: 0,
            isLast: true,
            values: [],
        });
        let resultCounter = 0;
        do {
            const queryParams = new URLSearchParams();
            queryParams.append('maxResults', `${maxResultsPerRequest}`);
            queryParams.append('startAt', `${resultCounter}`);
            for (const contextId of contextIds) {
                queryParams.append('contextId', `${contextId}`); // MUST BE PRESENT TO ONLY FETCH CONTEXTS USER HAS PERMISSIONS ON!
            }
            const sanitizedFieldId = sanitizeUserInput_fieldId(params.fieldId);
            const uriEscapedAndSafe = this.route `/rest/api/3/field/${sanitizedFieldId}/context?${queryParams}`;
            // console.log('ctx user ', uriEscapedAndSafe);
            const response = await this.api.asApp().requestJira(uriEscapedAndSafe);
            const errorAndPayloadInner = await transformJiraRestResponse(response, errorId);
            if (errorAndPayloadInner.hasError) {
                return errorAndPayloadInner;
            }
            resultCounter = resultCounter + toIntNullSafe(errorAndPayloadInner.payload.maxResults);
            errorAndPayload = concatenate_paginatedRestResult(errorAndPayload, errorAndPayloadInner);
        } while (errorAndPayload && errorAndPayload.hasError === false && errorAndPayload.payload && errorAndPayload.payload.isLast === false && resultCounter < maxResultsOverall);
        // FILTER
        if (params.currentFilter) {
            errorAndPayload.payload.values = errorAndPayload.payload.values.filter((c) => `${c.name}`.toLowerCase().includes(params.currentFilter.toLowerCase()) || `${c.description}`.toLowerCase().includes(params.currentFilter.toLowerCase()));
        }
        // NOW ONLY RETURN A SLICE FOR PAGINATION IN FRONTEND
        errorAndPayload.payload = paginateContextResultWithoutFilter(errorAndPayload.payload.values, {
            fieldId: params.fieldId,
            maxResults: maxResultsPerPaginatedPage,
            startAt: params.startAt,
            currentFilter: null,
        });
        return errorAndPayload;
    }
    //
    // Admin or global permission when user uses the filter to search for something (cannot be done via API)
    // Then 300 contexts are fetched and filtered in memory (rate limit)
    // Pagination is done in memory too. Only the desired slice is returned.
    //
    async rest_api_3_field_FIELDID_context___getAllCustomFieldContexts___forAdminOrGlobalPermissionWithFilterPaginated__asApp(params) {
        const errorId = 'FLDCONTEXTS_289774';
        const maxResultsPerPaginatedPage = 20; // Slice we want to show in frontend
        const maxResultsOverall = 300; // We limit it to max 3 requests (rate limit)
        const maxResultsPerRequest = 100; // NOTE: HARDCODED 100 maxResults limit by Atlassian!
        let resultCounter = 0;
        let errorAndPayload = returnNoErrorWithPayload({
            maxResults: 0,
            startAt: 0,
            total: 0,
            isLast: true,
            values: [],
        });
        do {
            const queryParams = new URLSearchParams();
            queryParams.append('maxResults', `${maxResultsPerRequest}`);
            queryParams.append('startAt', `${resultCounter}`);
            const sanitizedFieldId = sanitizeUserInput_fieldId(params.fieldId);
            const uriEscapedAndSafe = this.route `/rest/api/3/field/${sanitizedFieldId}/context?${queryParams}`;
            // console.log('ctx adminOrGlobal WITH Filter', uriEscapedAndSafe);
            const response = await this.api.asApp().requestJira(uriEscapedAndSafe);
            const errorAndPayloadInner = await transformJiraRestResponse(response, errorId);
            if (errorAndPayloadInner.hasError) {
                return errorAndPayloadInner;
            }
            resultCounter = resultCounter + toIntNullSafe(errorAndPayloadInner.payload.maxResults);
            errorAndPayload = concatenate_paginatedRestResult(errorAndPayload, errorAndPayloadInner);
        } while (errorAndPayload && errorAndPayload.hasError === false && errorAndPayload.payload && errorAndPayload.payload.isLast === false && resultCounter < maxResultsOverall);
        // FILTER
        if (params.currentFilter) {
            errorAndPayload.payload.values = errorAndPayload.payload.values.filter((c) => `${c.name}`.toLowerCase().includes(params.currentFilter.toLowerCase()) || `${c.description}`.toLowerCase().includes(params.currentFilter.toLowerCase()));
        }
        // NOW ONLY RETURN A SLICE FOR PAGINATION IN FRONTEND
        errorAndPayload.payload = paginateContextResultWithoutFilter(errorAndPayload.payload.values, {
            fieldId: params.fieldId,
            maxResults: maxResultsPerPaginatedPage,
            startAt: params.startAt,
            currentFilter: null,
        });
        return errorAndPayload;
    }
    //
    // Admin or global permission user uses normal pagination without filter
    // Then all contexts are returned paginated. Meaning we only get the slice from API we need to display.
    //
    async rest_api_3_field_FIELDID_context___getAllCustomFieldContexts___forAdminOrGlobalPermissionWithoutFilterPaginated___asApp(params) {
        const errorId = 'FLDCONTEXTS_639472';
        const maxResultsPerRequest = 20; // This is the page size we want to display in frontend!
        let errorAndPayload = returnNoErrorWithPayload({
            maxResults: 0,
            startAt: 0,
            total: 0,
            isLast: true,
            values: [],
        });
        const queryParams = new URLSearchParams();
        queryParams.append('maxResults', `${maxResultsPerRequest}`);
        queryParams.append('startAt', sanitizeUserInput_positiveNumber(`${params.startAt}`));
        const sanitizedFieldId = sanitizeUserInput_fieldId(params.fieldId);
        const uriEscapedAndSafe = this.route `/rest/api/3/field/${sanitizedFieldId}/context?${queryParams}`;
        // console.log('ctx adminOrGlobal Without Filter', uriEscapedAndSafe);
        const response = await this.api.asApp().requestJira(uriEscapedAndSafe, DEFAULT_JSON_HEADERS);
        errorAndPayload = await transformJiraRestResponse(response, errorId);
        if (errorAndPayload.hasError) {
            return errorAndPayload;
        }
        return errorAndPayload;
    }
    async rest_api_3_field_FIELDID_context_CONTEXTID_option___createOption___asApp(createOptionObj) {
        const errorId = 'CTXOPT_210983';
        const createObjForAPI = generateCreateObjectBasedOnParentOptionId_from_OptionDTOCreateOption(createOptionObj);
        // console.log('CREATE', JSON.stringify(createObjForAPI, null, 2));
        const sanitizedFieldId = sanitizeUserInput_fieldId(createOptionObj.fieldId);
        const sanitizedContextId = sanitizeUserInput_contextId(`${createOptionObj.contextId}`);
        const response = await this.api.asApp().requestJira(this.route `/rest/api/3/field/${sanitizedFieldId}/context/${sanitizedContextId}/option`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                options: [createObjForAPI],
            }),
        });
        // console.log('rest_api_3_field_FIELDID_context_CONTEXTID_option___createOption___asApp', JSON.stringify(response, null, 2));
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        return errorAndPayload;
    }
    async rest_api_3_field_FIELDID_context_CONTEXTID_option_move___moveOption___asApp(moveOptionObj) {
        const errorId = 'CTXOPT_843932';
        const sanitizedFieldId = sanitizeUserInput_fieldId(moveOptionObj.fieldId);
        const sanitizedContextId = sanitizeUserInput_contextId(`${moveOptionObj.contextId}`);
        const response = await this.api.asApp().requestJira(this.route `/rest/api/3/field/${sanitizedFieldId}/context/${sanitizedContextId}/option/move`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ customFieldOptionIds: [moveOptionObj.move.id], after: moveOptionObj.move.after, position: moveOptionObj.move.position }),
        });
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        return errorAndPayload;
    }
    async rest_api_3_field_FIELDID_context_CONTEXTID_option___updateOption___asApp(createOptionObj) {
        const errorId = 'CTXOPT_873623';
        const sanitizedFieldId = sanitizeUserInput_fieldId(createOptionObj.fieldId);
        const sanitizedContextId = sanitizeUserInput_contextId(`${createOptionObj.contextId}`);
        const response = await this.api.asApp().requestJira(this.route `/rest/api/3/field/${sanitizedFieldId}/context/${sanitizedContextId}/option`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                options: [createOptionObj.update],
            }),
        });
        // console.log('rest_api_3_field_FIELDID_context_CONTEXTID_option___updateOption___asApp', response);
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        return errorAndPayload;
    }
    async rest_api_3_field_FIELDID_context_CONTEXTID_option_OPTIONID___deleteOption___asApp(deleteOptionObj) {
        const errorId = 'CTXOPT_127332';
        const sanitizedFieldId = sanitizeUserInput_fieldId(deleteOptionObj.fieldId);
        const sanitizedContextId = sanitizeUserInput_contextId(`${deleteOptionObj.contextId}`);
        const sanitizedOptionId = sanitizeUserInput_optionId(`${deleteOptionObj.delete.id}`);
        const response = await this.api.asApp().requestJira(this.route `/rest/api/3/field/${sanitizedFieldId}/context/${sanitizedContextId}/option/${sanitizedOptionId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        // console.log('deleteOption', response);
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        return errorAndPayload;
    }
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: IMPLICIT-SAFE
     *            - because api.asUser() implicitly needs admin permissions to query for users via REST API
     *            - non-admin users get errors using this endpoint
     */
    async rest_api_3_user_picker___findUsersForPicker___asUser(query) {
        const errorId = 'ADMUP_324341';
        const queryParams = new URLSearchParams();
        const querySafe = sanitize_userOrGroupPickerQuery(query);
        queryParams.append('query', querySafe);
        queryParams.append('showAvatar', 'true');
        const response = await this.api.asUser().requestJira(this.route `/rest/api/3/user/picker?${queryParams}`);
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        if (errorAndPayload.hasError) {
            return returnError400WithEmptyPayload(errorAndPayload.errorMessage, errorId);
        }
        return returnNoErrorWithPayload(transformRestUserSearchResultToDTOs(errorAndPayload.payload));
    }
    /*
     * TYPE:     ADMIN ENDPOINT
     * SECURITY: IMPLICIT-SAFE
     *            - because api.asUser() implicitly needs admin permissions to query for users via REST API
     *            - non-admin users get errors using this endpoint
     */
    async rest_api_3_groups_picker___findGroupsForPicker___asUser(query) {
        const errorId = 'ADMGP_533122';
        const queryParams = new URLSearchParams();
        const querySafe = sanitize_userOrGroupPickerQuery(query);
        queryParams.append('query', querySafe);
        queryParams.append('showAvatar', 'true');
        const response = await this.api.asUser().requestJira(this.route `/rest/api/3/groups/picker?${queryParams}`);
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        if (errorAndPayload.hasError) {
            return returnError400WithEmptyPayload(errorAndPayload.errorMessage, errorId);
        }
        return returnNoErrorWithPayload(transformRestGroupSearchResultToDTOs(errorAndPayload.payload));
    }
    async rest_api_2_group_bulk___findGroupsByGroupIds___asApp(params) {
        const errorId = 'ADMFGI_258432';
        // /rest/api/2/group/bulk
        // https://developer.atlassian.com/cloud/jira/platform/rest/v2/api-group-groups/#api-rest-api-2-group-bulk-get
        if (params.groupIds && params.groupIds.length > 0 && params.groupIds.filter((a) => a != null).length > 0) {
            // We already know how many pages are returned because we query with all groupIds as params
            // params.maxResults MUSTE BE MAX 100 ! HAS TO BE ENFORCED IN RESOLVER ! JIRA BULK API CANNOT HANDLE MORE THAN 100 GROUPIDS AS PARAM
            const groupIdsCurrentPage = fromToSliceOfListNullSafe(params.groupIds, params.startAt, params.maxResults);
            if (groupIdsCurrentPage.length === 0) {
                // WE CANNOT QUERY THE API WITHOUT PARAMS, WILL RETURN RANDOM GROUPS INSTEAD!
                return returnNoErrorWithPayload({
                    maxResults: 10,
                    startAt: 0,
                    total: 0,
                    isLast: true,
                    values: [],
                });
            }
            const total = params.groupIds.length;
            const groupIdsParams = new URLSearchParams();
            for (const groupId of groupIdsCurrentPage) {
                if (groupId != null) {
                    groupIdsParams.append('groupId', sanitizeUserInput_groupId(groupId));
                }
            }
            groupIdsParams.append('maxResults', `${params.maxResults}`);
            groupIdsParams.append('startAt', `0`); // IMPORTANRT !! WE ALWAYS START AT 0 !!! BECAUSE THE PAGINATION HAPPENS BEFORE CALLING THE API!
            const urlEscaped = this.route `/rest/api/2/group/bulk?${groupIdsParams}`;
            const bulkGroupsResponse = await this.api.asApp().requestJira(urlEscaped, DEFAULT_JSON_HEADERS);
            const errorAndPayloadInner = await transformJiraRestResponse(bulkGroupsResponse, errorId);
            if (errorAndPayloadInner.hasError) {
                return returnErrorWithEmptyPayload(errorAndPayloadInner);
            }
            const groupsWithUnknownAsGroupName = transformGroupIdList_To_RestBulkGroupSearchResultItem__WithUnknownGroupNamePlaceholder(groupIdsCurrentPage);
            const finalGroupList = mergeLeft_GroupName_of_RestBulkGroupSearchResultItem(groupsWithUnknownAsGroupName, errorAndPayloadInner.payload.values);
            return returnNoErrorWithPayload({
                maxResults: params.maxResults,
                startAt: params.startAt,
                total: total,
                isLast: params.startAt + params.maxResults >= total,
                values: transformRestBulkGroupSearchResultToDTOs({
                    values: finalGroupList,
                    total: total,
                }),
            });
        }
        else {
            return returnNoErrorWithPayload({
                maxResults: 10,
                startAt: 0,
                total: 0,
                isLast: true,
                values: [],
            });
        }
    }
    async rest_api_3_user_bulk___findUsersByAccountIds___asApp(params) {
        const errorId = 'ADMFUI_863221';
        if (params.accountIds && params.accountIds.length > 0 && params.accountIds.filter((a) => a != null).length > 0) {
            const accountIdsCurrentPage = fromToSliceOfListNullSafe(params.accountIds, params.startAt, params.maxResults);
            if (accountIdsCurrentPage.length === 0) {
                // WE CANNOT QUERY THE API WITHOUT PARAMS, WILL RETURN RANDOM USERS INSTEAD!
                return returnNoErrorWithPayload({
                    maxResults: 10,
                    startAt: 0,
                    total: 0,
                    isLast: true,
                    values: [],
                });
            }
            const total = params.accountIds.length;
            const accountIdsParams = new URLSearchParams();
            for (const accountId of accountIdsCurrentPage) {
                if (accountId != null) {
                    accountIdsParams.append('accountId', sanitizeUserInput_accountId(accountId));
                }
            }
            accountIdsParams.append('maxResults', `${params.maxResults}`); // HARD CODED LIMIT
            accountIdsParams.append('startAt', `0`); // IMPORTANRT !! WE ALWAYS START AT 0 !!! BECAUSE THE PAGINATION HAPPENS BEFORE CALLING THE API!
            const urlEscaped = this.route `/rest/api/3/user/bulk?${accountIdsParams}`;
            const bulkUsersResponse = await this.api.asApp().requestJira(urlEscaped, DEFAULT_JSON_HEADERS);
            const errorAndPayloadBulkUser = await transformJiraRestResponse(bulkUsersResponse, errorId);
            if (errorAndPayloadBulkUser.hasError) {
                return returnErrorWithEmptyPayload(errorAndPayloadBulkUser);
            }
            else {
                const accountsWithUnknownAsDisplayName = transformUserAccountIdList_To_RestBulkUserSearchResultItem__WithUnknownDisplayNamePlaceholder(accountIdsCurrentPage);
                const finalUserList = mergeLeft_DisplayNameAndAvatarUrl_of_RestBulkUserSearchResultItem(accountsWithUnknownAsDisplayName, errorAndPayloadBulkUser.payload.values);
                return returnNoErrorWithPayload({
                    maxResults: params.maxResults,
                    startAt: params.startAt,
                    total: total,
                    isLast: params.startAt + params.maxResults >= total,
                    values: transformRestBulkUserSearchResultToDTOs({
                        values: finalUserList,
                        total: total,
                    }),
                });
            }
        }
        else {
            return returnNoErrorWithPayload({
                maxResults: 10,
                startAt: 0,
                total: 0,
                isLast: true,
                values: [],
            });
        }
    }
    async rest_api_3_field_context_defaultValue___getDefaultOptionsForContext___asApp(fieldId, contextId, fieldType) {
        const errorId = 'CTXDEF_047231';
        const maxResultsOverall = 150; // We limit it to max 3 requests (rate limit)
        const maxResultsPerRequest = 50; // NOTE: HARDCODED 50 maxResults limit by Atlassian!
        let resultCounter = 0;
        let errorAndPayload = returnNoErrorWithPayload({
            maxResults: 0,
            startAt: 0,
            total: 0,
            isLast: true,
            values: [],
        });
        do {
            const queryParams = new URLSearchParams();
            const sanitizedContextId = sanitizeUserInput_contextId(contextId);
            queryParams.append('contextId', `${sanitizedContextId}`);
            queryParams.append('startAt', `${resultCounter}`);
            queryParams.append('maxResults', `${maxResultsPerRequest}`);
            const sanitizedFieldId = sanitizeUserInput_fieldId(fieldId);
            const uriEscapedAndSafe = this.route `/rest/api/3/field/${sanitizedFieldId}/context/defaultValue?${queryParams}`;
            const response = await this.api.asApp().requestJira(uriEscapedAndSafe);
            const errorAndPayloadInner = await transformJiraRestResponse(response, errorId);
            if (errorAndPayloadInner.hasError) {
                return returnErrorWithEmptyPayload(errorAndPayloadInner);
            }
            resultCounter = resultCounter + toIntNullSafe(errorAndPayloadInner.payload.maxResults);
            errorAndPayload = concatenate_paginatedRestResult(errorAndPayload, errorAndPayloadInner);
        } while (errorAndPayload && errorAndPayload.hasError === false && errorAndPayload.payload && errorAndPayload.payload.isLast === false && resultCounter < maxResultsOverall);
        // TRANSFORM TO DTO
        const dtoResult = transformRestDefaultValuesToDTOs(errorAndPayload.payload, fieldType);
        return returnNoErrorWithPayload(dtoResult);
    }
    async rest_api_3_field_context_defaultValue___setDefaultOptionsForContext___asApp(setDefaultObj, fieldTypeShort) {
        const errorId = 'CTXDEF_947213';
        const sanitizedFieldId = sanitizeUserInput_fieldId(setDefaultObj.fieldId);
        const httpBodyObj = transformDTOSetDefaultOptionToRESTrepresentationForHttpPut(setDefaultObj, fieldTypeShort);
        const response = await this.api.asApp().requestJira(this.route `/rest/api/3/field/${sanitizedFieldId}/context/defaultValue`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(httpBodyObj),
        });
        const errorAndPayload = await transformJiraRestResponse(response, errorId);
        return errorAndPayload;
    }
}
